import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatInputModule } from "@angular/material/input";
import { MatNativeDateModule } from "@angular/material/core";
import { IonicModule } from "@ionic/angular";

import { NavbarComponent } from "./navbar/navbar.component";
import { HomepageComponent } from "./homepage/homepage.component";
import { UtilityDashboardComponent } from "./utility-dashboard/utility-dashboard.component";
import { SmartMeterDataComponent } from "./smart-meter-data/smart-meter-data.component";
import { BidHistoryComponent } from "./bid-history/bid-history.component";
import { SettlementComponent } from "./settlement/settlement.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { CircleComponent } from "./circle/circle.component";

@NgModule({
  declarations: [
    NavbarComponent,
    HomepageComponent,
    UtilityDashboardComponent,
    SmartMeterDataComponent,
    BidHistoryComponent,
    SettlementComponent,
    DashboardComponent,
    CircleComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    IonicModule
  ],
  exports: [
    NavbarComponent,
    HomepageComponent,
    UtilityDashboardComponent,
    SmartMeterDataComponent,
    BidHistoryComponent,
    SettlementComponent,
    DashboardComponent,
    CircleComponent
  ]
})
export class UtilityModule {}
